import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, thirdWidth } from "../../blocks/layout/columnSpans";

/**
 * Opponent Type as page config. The warehouse record carries only a name - EntityPage summarises
 * created and modified in the footer.
 */
export const opponentTypePageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "dwopponenttype",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: fullWidth,
          blocks: [
            {
              kind: "section",
              id: "section-opponent-type",
              // The page bar already names the record, and there is one field.
              title: "",
              fields: [
                {
                  id: "field-name",
                  type: "text",
                  name: "name",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  span: thirdWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
